var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1149_19899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 5.25H11.25V4C11.25 3.13805 10.9076 2.3114 10.2981 1.7019C9.6886 1.09241 8.86195 0.75 8 0.75C7.13805 0.75 6.3114 1.09241 5.7019 1.7019C5.09241 2.3114 4.75 3.13805 4.75 4V5.25H3C2.66848 5.25 2.35054 5.3817 2.11612 5.61612C1.8817 5.85054 1.75 6.16848 1.75 6.5V13.5C1.75 13.8315 1.8817 14.1495 2.11612 14.3839C2.35054 14.6183 2.66848 14.75 3 14.75H13C13.3315 14.75 13.6495 14.6183 13.8839 14.3839C14.1183 14.1495 14.25 13.8315 14.25 13.5V6.5C14.25 6.16848 14.1183 5.85054 13.8839 5.61612C13.6495 5.3817 13.3315 5.25 13 5.25ZM6.25 4C6.25 3.53587 6.43437 3.09075 6.76256 2.76256C7.09075 2.43437 7.53587 2.25 8 2.25C8.46413 2.25 8.90925 2.43437 9.23744 2.76256C9.56563 3.09075 9.75 3.53587 9.75 4V5.25H6.25V4ZM12.75 13.25H3.25V6.75H12.75V13.25ZM9 10C9 10.1978 8.94135 10.3911 8.83147 10.5556C8.72159 10.72 8.56541 10.8482 8.38268 10.9239C8.19996 10.9996 7.99889 11.0194 7.80491 10.9808C7.61093 10.9422 7.43275 10.847 7.29289 10.7071C7.15304 10.5673 7.0578 10.3891 7.01921 10.1951C6.98063 10.0011 7.00043 9.80004 7.07612 9.61732C7.15181 9.43459 7.27998 9.27841 7.44443 9.16853C7.60888 9.05865 7.80222 9 8 9C8.26522 9 8.51957 9.10536 8.70711 9.29289C8.89464 9.48043 9 9.73478 9 10Z",
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1149_19899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.134c7de53f7c1f4a5ac357447bf6d7fd.svg";
export { ForwardRef as ReactComponent };